import { BoxContainer } from '@/components';
import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import { JSX } from 'react';
import { QuestionsAnswersInner } from './parts';
import styles from './styles.module.scss';

export type QuestionsAnswersProps =
  SliceComponentProps<Content.QuestionsAnswersSlice>;

const QuestionsAnswers = ({ slice }: QuestionsAnswersProps): JSX.Element => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      id={slice.id}
    >
      <BoxContainer styles={styles.container}>
        <QuestionsAnswersInner slice={slice} />
      </BoxContainer>
    </section>
  );
};

export default QuestionsAnswers;
